import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: 'user',
    initialState: {
      user: null,
      store: 1
    },
    reducers: {
      loginSuccess: (state, action) => {
        state.user = action.payload;
      },
      logoutSuccess: (state, action) =>  {
        state.user = null;
      },
      currentStore: (state, action) => {
        state.store = action.payload;
      },
    }
})

export const { loginSuccess, logoutSuccess, currentStore } = userSlice.actions;

export default userSlice.reducer;